import { Component } from '../../../../../lib/web/components/component';
import { ModalComponent } from '../../../../../lib/web/components/modal.component';

@Component({
    selector: '.m-view-detail'
})
export class ViewDetailComponent extends ModalComponent<HTMLInputElement> {

    public constructor(node: HTMLInputElement) {
        super(node);
    }    

    public async open(data?: { title: string, content: string }): Promise<any> {
        this.node.querySelector('.m-view-detail__title').innerHTML = data?.title || '';
        this.node.querySelector('.m-view-detail__text').innerHTML = data?.content || '';
        return super.open();
    }   
}